module.exports = __webpack_public_path__ + "img/TTC.97b59ef6.svg";